/*eslint-disable*/
import React from "react";
import Loader from 'react-loader-spinner'

export default function LoadingScreen(props) {
  const { color="#0797ed", position='absolute' } = props
  return (
    <div
      style={{
          position: position, 
          left: '50%', 
          top: '50%',
          transform: 'translate(-50%, -50%)',
          display: position === 'absolute' ? 'unset' : 'flex',
          justifyContent: position === 'absolute' ? 'unset' : 'center',
          alignItems: position === 'absolute' ? 'unset' : 'center',
          justifySelf: position === 'absolute' ? 'unset' : 'center'
      }}
    >
      <Loader
        type="ThreeDots"
        color={color}
        height={100}
        width={100}
        visible={true}
      />
    </div>
  );
}